

export default {
  init() {
    document.addEventListener( 'wpcf7mailsent', function() {
      $('.block-contact-form__inner-wrapper').css('display', 'none')
    }, false );

    //Conact form textarea auto size 
    $('.wpcf7-form-control-wrap').on( 'change keyup keydown paste cut', 'textarea', function (){
      $(this).height(0).height(this.scrollHeight - 30);
    }).find( 'textarea' ).change();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js